// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"3fd518a0","703":"94ee8368"}[chunkId] + ".chunk.js";
};